import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { RunCandidateScore } from 'src/app/core/models/runCandidateScore';
import { JobMatchQueryFilter } from 'src/app/core/models/jobMatchQueryFilter';
import { FormalizeCandidate, FormalizeCompany, FormalizeJobMatch, FormalizeRequisition } from 'src/app/core/models/formalizePayload';
import { AuthService } from 'src/app/core/services/auth.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { JobMatchService } from 'src/app/core/services/job-match.service';
import { JobMatchActionsService } from 'src/app/core/services/job-match-actions.service';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { ResumeService } from 'src/app/core/services/resume.service';
import { UserRoleService } from 'src/app/core/services/user-role.service';
import { CompanyService } from 'src/app/core/services/company.service';
import { SharedService } from 'src/app/core/services/shared.service';
import { FourDotFiveDateFormatPipe } from 'src/app/core/pipes/four-dot-five-date-format.pipe';
import { WebSocketsService } from 'src/app/core/services/web-sockets.service';

declare var libphonenumber: any;

@Component({
  selector: 'app-candidate-job-match-card',
  templateUrl: './candidate-job-match-card.component.html',
  styleUrls: ['./candidate-job-match-card.component.css'],
  providers: [FourDotFiveDateFormatPipe]
})
export class CandidateJobMatchCardComponent implements OnInit, OnDestroy {

  @Input() candidateId: any;
  @Input() jobMatchId: any;
  @Input() jobLocation: any;
  @Input() requisitionSponsorships: any;
  @Input() jobWorkLocations: any;
  @Input() context: any;
  @Input() candidateJobMatch: any;
  @Input() salaryDurationOptions: any;
  @Input() disabledFlag = false;
  @Input() activityMap: any;
  @Input() jobTypeList: any;
  @Input() allRecruitersAndHiringManagers: any;
  @Input() assignedVendorDetails: any;
  @Input() isFirstStep: any;
  @Input() workflowFirstStep: any;
  @Input() isOutreachEnabled: any;
  @Input() resumeRequiredForWorkflow: any;
  @Output() saveCallback = new EventEmitter<any>();

  private workFlowUpdateSubscription!: Subscription;
  private incomingChatMessageSubscription!: Subscription;

  notesTooltipIsOpen = false;
  candidateJobMatches: any[] = [];
  notificationsSearchObject: any = {};
  userNotificationControls: any = {};
  recentActivitiesControls: any = {};
  isActivityClicked = false;
  isNotificationClicked = false;
  numberOfNewNotifications = 0;
  communicationActionObject: any = null;
  peerCommunicationActionObject: any = null;
  notesActionObject: any = null;
  assignRecruiterActionObject: any = null;
  notInterestedActionObject: any = null;
  releaseActionObject: any = null;
  jobMatchScoreTitle = 'Job Match Score';
  updateContactActionObject: any;
  candidateJobCompareActionObject: any;
  candidateProfileActionObject: any;
  sendEmailProfileActionObject: any;
  reRunScoreActionObject: any;
  sendPeerEmailProfileActionObject: any;
  uploadResumeActionObject: any;
  clientReviewActionObject: any;

  dirtyFlag = false;
  loadingFlag = true;
  loadingMeetingsFlag = true;
  refreshingJobMatchStatusFlag = false;
  showIntelligenceScoreFlag = false;
  intelligenceScorePassFlag = false;
  showTechAssessmentScoreFlag = false;
  techAssessmentScorePassFlag = false;
  showValueAssessmentScoreFlag = false;
  showCommunicationFlag = false;
  showPeerCommunicationFlag = false;
  showNotesFlag = false;
  showAssignRecruiterFlag = false;
  showNotInterestedFlag = false;
  showReleaseFlag = false;
  showInterviewCountFlag = false;
  showPhoneScreenCountFlag = false;
  showAssessmentInfoFlag = false;
  isCorporateFlag = false;
  disableProfileLink = false;
  showNotificationsFlag = false;
  showRecentActivitiesFlag = false;
  showAdditionalDetailsIconsFlag = false;
  showSalary = true;
  isVendorOnly = false;

  userId: any;
  companyId: any;
  isSuperUser = false;
  is4dot5UserAdmin = false;
  notesDisplay = '';
  filledJoinedDetailsPopoverIsOpenFlag = false;

  constructor(
    @Inject(WebSocketsService) private webSocketsService: WebSocketsService,
    private authService: AuthService,
    private storageService: StorageService,
    private jobMatchService: JobMatchService,
    private jobMatchActionsService: JobMatchActionsService,
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private resumeService: ResumeService,
    private userRoleService: UserRoleService,
    private companyService: CompanyService,
    private sharedService: SharedService,
    private fourDotFiveDateFormatPipe: FourDotFiveDateFormatPipe
  ) { }

  ngOnInit() {
    this.candidateJobMatches = [];
    this.notificationsSearchObject = {};
    this.userNotificationControls = { notificationClickCount: 0 };
    this.recentActivitiesControls = { activityClickCount: 0 };
    this.isActivityClicked = false;
    this.isNotificationClicked = false;
    this.numberOfNewNotifications = 0;
    this.communicationActionObject = null;
    this.peerCommunicationActionObject = null;
    this.notesActionObject = null;
    this.assignRecruiterActionObject = null;
    this.notInterestedActionObject = null;
    this.releaseActionObject = null;
    this.jobMatchScoreTitle = 'Job Match Score';
    this.updateContactActionObject = {
      action: 'Update Candidate Details',
      actionType: 'UPDATE_CONTACT',
      allowed: true,
      message: null
    };
    this.candidateJobCompareActionObject = {
      action: 'Candidate Job Comparison',
      actionType: 'CANDIDATE_JOB_COMPARE',
      allowed: true,
      message: null,
      candidateDetails: this._setJobMatchCandidateDetails('booklet', this.candidateJobMatch)
    };
    const candidateName = this.candidateJobMatch.firstName + ' ' + this.candidateJobMatch.lastName;
    this.candidateProfileActionObject = {
      action: candidateName + "'s" + ' ' + 'Booklet',
      actionType: 'CANDIDATE_PROFILE',
      allowed: true,
      message: null,
      candidateDetails: this._setJobMatchCandidateDetails('booklet', this.candidateJobMatch)
    };
    this.sendEmailProfileActionObject = {
      action: 'Send Email',
      actionType: 'SEND_EMAIL',
      allowed: true,
      message: null,
      candidateDetails: this._setJobMatchCandidateDetails('email', this.candidateJobMatch)
    };
    this.reRunScoreActionObject = {
      action: 'Run Candidate Score',
      actionType: 'RUN_CANDIDATE_SCORE',
      allowed: true,
      message: null,
      displayAction: true
    };
    this.sendPeerEmailProfileActionObject = _.cloneDeep(this.sendEmailProfileActionObject);
    this.sendPeerEmailProfileActionObject.candidateDetails.candidateEmail = null;
    this.uploadResumeActionObject = {
      actionType: 'UPLOAD_RESUME',
      action: 'Upload Resume',
      message: null,
      allowed: true
    };

    this.disabledFlag = false;
    this.dirtyFlag = false;
    this.loadingFlag = true;
    this.loadingMeetingsFlag = true;
    this.refreshingJobMatchStatusFlag = false;
    this.showIntelligenceScoreFlag = false;
    this.intelligenceScorePassFlag = false;
    this.showTechAssessmentScoreFlag = false;
    this.techAssessmentScorePassFlag = false;
    this.showValueAssessmentScoreFlag = false;
    this.showCommunicationFlag = false;
    this.showPeerCommunicationFlag = false;
    this.showNotesFlag = false;
    this.showAssignRecruiterFlag = false;
    this.showNotInterestedFlag = false;
    this.showReleaseFlag = false;
    this.showInterviewCountFlag = false;
    this.showPhoneScreenCountFlag = false;
    this.showAssessmentInfoFlag = false;
    this.isCorporateFlag = false;
    this.disableProfileLink = false;
    this.showNotificationsFlag = false;
    this.showRecentActivitiesFlag = false;
    this.showAdditionalDetailsIconsFlag = false;
    this.showSalary = true;
    this.isVendorOnly = this.companyService.isCompanyVendor();

    this.init(false);

    this.clientReviewActionObject = {
      action: 'Client Review',
      actionType: 'CLIENT_REVIEW',
      allowed: true,
      message: null,
      clientReviewDetails: true
    };
  }

  init(isRefresh) {
    const userDetails = this.authService.getUserDetails();
    this.userId = userDetails.id;
    this.companyId = userDetails.company.companyId;
    this.isCorporateFlag = (userDetails.company.companyType === 'Corporation');
    this.isSuperUser = this.userRoleService.isLoggedInUserSuperUser();
    this.is4dot5UserAdmin = this.userRoleService.isLoggedInUser4dot5Admin();
    this.numberOfNewNotifications = 0;
    this.notificationsSearchObject.page = 1;
    this.notificationsSearchObject.size = 3;
    this.notificationsSearchObject.jobMatchId = this.jobMatchId;
    this.notificationsSearchObject.companyId = this.companyId;
    this.notificationsSearchObject.notifyOn = 'CANDIDATE_JOB_CARD';
    this.userNotificationControls.setNewNotificationsAsViewed = null;
    this.recentActivitiesControls.getActivities = null;
    this.showNotificationsFlag = true;
    this.showRecentActivitiesFlag = true;
    this.showAdditionalDetailsIconsFlag = false;
    if (this.activityMap === undefined) {
      this.activityMap = [];
    }
    if (isRefresh) {
      this.candidateJobMatchCopy = { ...this.candidateJobMatch };
    }
    if (isRefresh || this.context !== 'workflow') {
      this.getCandidateJobMatchCardInfo();
    } else {
      this.candidateJobMatch = this._massageCandidateJobMatchData(this.candidateJobMatch);
      this._setActionsOnTheCard();
      this.loadingFlag = false;
    }
    if (!isRefresh) {
      this.listenToStateUpdate();
      this.listenToIncomingChatMessage();
    }
  }

  private candidateJobMatchCopy: any;

  refreshCard() {
    if (!this.loadingFlag) {
      this._resetAndRefreshCard();
    }
  }

  private _resetAndRefreshCard() {
    this.loadingFlag = true;
    this.loadingMeetingsFlag = true;
    this.showIntelligenceScoreFlag = false;
    this.intelligenceScorePassFlag = false;
    this.showTechAssessmentScoreFlag = false;
    this.techAssessmentScorePassFlag = false;
    this.showValueAssessmentScoreFlag = false;
    this.showCommunicationFlag = false;
    this.showPeerCommunicationFlag = false;
    this.showNotesFlag = false;
    this.showAssignRecruiterFlag = false;
    this.showNotInterestedFlag = false;
    this.showReleaseFlag = false;
    this.communicationActionObject = null;
    this.peerCommunicationActionObject = null;
    this.notesActionObject = null;
    this.assignRecruiterActionObject = null;
    this.notInterestedActionObject = null;
    this.releaseActionObject = null;
    this.showInterviewCountFlag = false;
    this.showPhoneScreenCountFlag = false;
    this.showAssessmentInfoFlag = false;
    this.showNotificationsFlag = false;
    this.showRecentActivitiesFlag = false;
    this.showAdditionalDetailsIconsFlag = false;
    setTimeout(() => {
      this.init(true);
    }, 300);
  }

  listenToStateUpdate() {
    this.workFlowUpdateSubscription = this.jobMatchService.refreshJobMatchCard.subscribe((stateChange) => {
      if (stateChange.jobmatchId == this.jobMatchId) {
        if (stateChange.refreshWorkflow) {
          this.disabledFlag = true;
          this.dirtyFlag = true;
        } else {
          this.refreshCard();
        }
      }
    });
  }

  listenToIncomingChatMessage() {
    this.incomingChatMessageSubscription = this.webSocketsService.receiveMessage().subscribe((message) => {
      if (message.jobMatchId == this.jobMatchId) {
        this.candidateJobMatch.unreadChatMessageCount++;
      }
    });
  }

  getReport(assessmentType, isSectionalReport, reportUrl) {
    let testInvitationId = this.candidateJobMatch.techAssessmentInvitationId;
    if (assessmentType == 'Value') {
      testInvitationId = this.candidateJobMatch.valueAssessmentInvitationId;
    }
    this.jobMatchActionsService.getReport(this.jobMatchId, assessmentType, isSectionalReport, reportUrl, testInvitationId);
  }

  updateCandidateJobCardDetails() {
    this.candidateJobCompareActionObject.candidateDetails = this._setJobMatchCandidateDetails('booklet', this.candidateJobMatch);
    this.candidateProfileActionObject.candidateDetails = this._setJobMatchCandidateDetails('booklet', this.candidateJobMatch);
    this.sendEmailProfileActionObject.candidateDetails = this._setJobMatchCandidateDetails('email', this.candidateJobMatch);
  }

  getCandidateJobMatchCardInfo(successCallback?, errorCallback?) {
    this.disableProfileLink = false;
    this.jobMatchService.getCandidateJobMatchCard(this.jobMatchId, this.companyId, (data) => {
      this.candidateJobMatch.availableActions = [];
      this.candidateJobMatch = angular.merge(this.candidateJobMatch, data);
      this.candidateJobMatch = this._massageCandidateJobMatchData(this.candidateJobMatch);
      this._setActionsOnTheCard();
      this.loadingFlag = false;
      if (!this.candidateJobMatch.id) {
        this.jobMatchService.requestJobMatchCardRemoval(this.candidateJobMatchCopy);
      }
      this.updateCandidateJobCardDetails();
      if (successCallback) {
        successCallback();
      }
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      if (errorCallback) {
        errorCallback();
      }
    }, undefined);
  }

  private _setActionsOnTheCard() {
    this._setActionFlags();
    this._removeCommonCardHeaderActions();
    let availableActionsToDisplay = [];
    const updateResumeIndex = this.candidateJobMatch.availableActions.findIndex(item => item.action === 'Upload Resume');
    if (updateResumeIndex !== -1 && (this.is4dot5UserAdmin || this.isSuperUser)) {
      this.candidateJobMatch.availableActions.splice(updateResumeIndex + 1, 0, this.reRunScoreActionObject);
    }
    if (this.candidateJobMatch.availableActions) {
      availableActionsToDisplay = this.candidateJobMatch.availableActions.filter((action) => action.displayAction == true);
    }
    if ((this.candidateJobMatch.currentStep != 'Not Interested' && this.candidateJobMatch.currentStep != 'Released') && this.candidateJobMatch.email && this.isOutreachEnabled) {
      const indexToRemove = _.findIndex(this.candidateJobMatch.availableActions, { actionType: 'SEND_OUTREACH' });
      let element = null;

      if (indexToRemove !== -1) {
        element = this.candidateJobMatch.availableActions.splice(indexToRemove, 1)[0];
      }

      if (element) {
        const uploadIndex = _.findIndex(this.candidateJobMatch.availableActions, { action: 'Upload Resume' });
        if (uploadIndex !== -1) {
          this.candidateJobMatch.availableActions.splice(uploadIndex + 1, 0, element);
        } else {
          this.candidateJobMatch.availableActions.push(element);
        }
      }
    } else {
      this.candidateJobMatch.availableActions = this.candidateJobMatch.availableActions.filter(action => {
        return !(action.actionType === 'SEND_OUTREACH' && action.allowed === false);
      });
    }
    if (availableActionsToDisplay.length == 0) {
      this.candidateJobMatch.availableActions = this.candidateJobMatch.availableActions ? this.candidateJobMatch.availableActions : [];
      this.candidateJobMatch.availableActions.push({
        action: 'No Actions Available!',
        actionType: 'NO_ACTIONS_AVAILABLE',
        allowed: true,
        message: null,
        displayAction: true
      });
    }
    this._setDisplayFlags();
    if (this.isFirstStep && (!this.candidateJobMatch.resumeFileName || this.candidateJobMatch.resumeFileName === '') &&
      (!this.candidateJobMatch.resumePdfFileName || this.candidateJobMatch.resumePdfFileName === '')) {
      this.candidateJobMatch.availableActions.forEach(action => {
        if (action.actionType != 'UPLOAD_RESUME' && action.actionType != 'DELETE_JOBMATCH' && action.actionType != 'SEND_OUTREACH') {
          action.isDisabled = true;
        } else {
          action.isDisabled = false;
        }
      });
    }

    this.candidateJobMatch.availableActions.forEach(action => {
      if (action.actionType === 'SEND_OUTREACH') {
        action.isDisabled = this.candidateJobMatch.isOutreachDisabled;
      }
    });
  }

  private _massageCandidateJobMatchData(candidateJobMatch) {
    candidateJobMatch.name = this._setCandidateName(candidateJobMatch);
    candidateJobMatch.jobMatchDate = new Date(candidateJobMatch.jobMatchDate);
    candidateJobMatch.jobLocation = this.jobLocation;
    if (candidateJobMatch.jobMatchRequisitionNum === null) {
      candidateJobMatch.jobMatchRequisitionNum = '-';
    }
    if (candidateJobMatch.fromOtherSource) {
      candidateJobMatch.otherSourceNote = '<span>Source: Other<br>Notes: ' + candidateJobMatch.otherSourceTypeNotes + '</span>';
    }
    candidateJobMatch.primaryRecruiter = {};
    candidateJobMatch.primaryRecruiterName = '';
    candidateJobMatch.corpRecruiters = [];
    candidateJobMatch.vendorRecruiters = [];
    let tempPrimaryRecruiterIndex = -1;
    if (candidateJobMatch.recruitersList !== null && candidateJobMatch.recruitersList.length) {
      candidateJobMatch.recruitersList.forEach((val, key) => {
        val.name = val.firstName;
        if (val.lastName !== null) {
          val.name += ' ' + val.lastName;
        }
        if (val.isPrimary && ((this.isCorporateFlag && !val.vendorRecruiter) || (!this.isCorporateFlag))) {
          candidateJobMatch.primaryRecruiter = val;
          candidateJobMatch.primaryRecruiterName = val.name;
          candidateJobMatch.isPrimaryRecruiterVendor = val.vendorRecruiter;
          tempPrimaryRecruiterIndex = key;
        } else if (val.vendorRecruiter) {
          candidateJobMatch.vendorRecruiters.push(val);
        } else {
          candidateJobMatch.corpRecruiters.push(val);
        }
      });
    }
    if (tempPrimaryRecruiterIndex != -1) {
      candidateJobMatch.recruitersList.splice(tempPrimaryRecruiterIndex, 1);
    }
    if (candidateJobMatch.candidateStatus === null) {
      candidateJobMatch.candidateStatus = 'Active';
    }
    if (candidateJobMatch.jobMatchStatus === null) {
      candidateJobMatch.jobMatchStatus = 'ACTIVE';
    }
    candidateJobMatch.numberOfOpenOpenings = (candidateJobMatch.totalOpenings - candidateJobMatch.numberOfFilledOpenings);
    if (candidateJobMatch.jobMatchCurrentState) {
      candidateJobMatch.jobMatchCurrentStateDisplayLabel = candidateJobMatch.jobMatchCurrentState.replace('Cancelled', 'Canceled');
    }
    candidateJobMatch.filledOrJoinedInOtherJobHeaderText = candidateJobMatch.joinedInOtherJob ? 'Joined' : (candidateJobMatch.filledInOtherJob ? 'Filled' : '');
    candidateJobMatch.filledOrJoinedInOtherJobMatchPopOverTitle = candidateJobMatch.joinedInOtherJob ? 'Joined Requisition Details' : (candidateJobMatch.filledInOtherJob ? 'Filled Requisition Details' : '');
    if (candidateJobMatch.mobilePhoneCountryCodePresent && candidateJobMatch.mobilephone) {
      const phoneNumberObject = libphonenumber.parse(candidateJobMatch.mobilephone.toString());
      if (phoneNumberObject.phone !== undefined) {
        candidateJobMatch.mobilephone = libphonenumber.format(phoneNumberObject.phone, phoneNumberObject.country, 'International');
      }
    }
    this.showAdditionalDetailsIconsFlag = true;
    this.notesDisplay = '';
    if (candidateJobMatch.reason !== null) {
      this.notesDisplay = this.notesDisplay + '<b>Reason: </b><p>' + candidateJobMatch.reason + ' </p>';
    }
    if (candidateJobMatch.mutipleNotePresent) {
      const multipleNotesExistNote = "<b class='brown'>Multiple Notes available</b>";
      this.notesDisplay = this.notesDisplay + multipleNotesExistNote + '<br>';
    } else {
      if (candidateJobMatch.jobMatchCurrentStateInternalNote !== null && candidateJobMatch.jobMatchCurrentStateInternalNote.length > 0) {
        if (candidateJobMatch.isSharedRequisition) {
          this.notesDisplay = this.notesDisplay + '<b>Internal Note: </b> <p>' + this._replaceSpecialCharacters(candidateJobMatch.jobMatchCurrentStateInternalNote) + '</p>';
        } else {
          this.notesDisplay = this.notesDisplay + '<b>Note: </b><p>' + this._replaceSpecialCharacters(candidateJobMatch.jobMatchCurrentStateInternalNote) + '</p>';
        }
      }
      if (candidateJobMatch.jobMatchCurrentStateExternalNote !== null && candidateJobMatch.jobMatchCurrentStateExternalNote.length > 0) {
        this.notesDisplay = this.notesDisplay + '<b>External Note: </b><br><p>' + this._replaceSpecialCharacters(candidateJobMatch.jobMatchCurrentStateExternalNote) + '</p>';
      }
    }

    if (this.notesDisplay.length !== 0) {
      this.notesDisplay = "<div class='text-left'>" + this.notesDisplay + '</div>';
    }
    candidateJobMatch.violationType = '';
    if (candidateJobMatch.techAssessmentReportInfoList.length > 0) {
      candidateJobMatch.violationType = candidateJobMatch.techAssessmentReportInfoList[candidateJobMatch.techAssessmentReportInfoList.length - 1].type;
    }
    if (this.isCorporateFlag && this.candidateJobMatch.vendorName !== null) {
      this.showSalary = false;
    }
    candidateJobMatch.workLocationsMatchStatus = this.jobMatchService.getJobAndCandidateWorkLocationsMatchStatus(this.jobWorkLocations, candidateJobMatch.workLocations);
    const outreachState = candidateJobMatch.outreachState ? candidateJobMatch.outreachState : '';
    if (outreachState && outreachState != '') {
      candidateJobMatch.outreachIconStatus = this.sharedService.setOutreachIconStatus(outreachState);
    }
    return candidateJobMatch;
  }

  private _setCandidateName(candidate) {
    if (candidate.firstName === null) {
      candidate.firstName = '-';
    }
    if (candidate.lastName === null) {
      candidate.lastName = '-';
    }
    if (candidate.firstName == '-' && candidate.lastName == '-') {
      candidate.nameWarning = 'First and Last Name Missing';
    } else if (candidate.firstName == '-') {
      candidate.nameWarning = 'First Name Missing';
    } else if (candidate.lastName == '-') {
      candidate.nameWarning = 'Last Name Missing';
    } else {
      candidate.nameWarning = '';
    }
    return candidate.firstName + ' ' + candidate.lastName;
  }

  private _replaceSpecialCharacters(text) {
    let replacedText = text;
    for (let i = 0; i < replacedText.length; i++) {
      replacedText = replacedText.replace('<', '&lt;').replace('>', '&gt;');
    }
    replacedText = replacedText.replace(/&lt;br&gt;/g, '<br>');
    return replacedText;
  }

  private _setActionFlags() {
    let tempObject = _.find(this.candidateJobMatch.availableActions, { actionType: 'COMMUNICATION' });
    this.showCommunicationFlag = tempObject !== undefined;
    if (this.showCommunicationFlag) {
      this.communicationActionObject = angular.copy(tempObject);
    }
    tempObject = _.find(this.candidateJobMatch.availableActions, { actionType: 'PEER_COMMUNICATION' });
    this.showPeerCommunicationFlag = tempObject !== undefined;
    if (this.showPeerCommunicationFlag) {
      this.peerCommunicationActionObject = tempObject;
    }
    tempObject = _.find(this.candidateJobMatch.availableActions, { actionType: 'NOTES' });
    this.showNotesFlag = tempObject !== undefined;
    if (this.showNotesFlag) {
      this.notesActionObject = tempObject;
    }
    tempObject = _.find(this.candidateJobMatch.availableActions, { actionType: 'ASSIGN_RECRUITER' });
    this.showAssignRecruiterFlag = tempObject !== undefined;
    if (this.showAssignRecruiterFlag) {
      this.assignRecruiterActionObject = tempObject;
    }
    tempObject = _.find(this.candidateJobMatch.availableActions, { actionType: 'NOT_INTERESTED' });
    this.showNotInterestedFlag = tempObject !== undefined;
    if (this.showNotInterestedFlag) {
      this.notInterestedActionObject = tempObject;
    }
    tempObject = _.find(this.candidateJobMatch.availableActions, { actionType: 'RELEASE' });
    this.showReleaseFlag = tempObject !== undefined;
    if (this.showReleaseFlag) {
      this.releaseActionObject = tempObject;
    }
  }

  private _removeCommonCardHeaderActions() {
    this.candidateJobMatch.availableActions.forEach((action) => {
      if (action.actionType == 'COMMUNICATION'
        || action.actionType == 'PEER_COMMUNICATION'
        || action.actionType == 'NOTES'
        || action.actionType == 'ASSIGN_RECRUITER'
        || action.actionType == 'RELEASE'
        || action.actionType == 'NOT_INTERESTED') {
        action.displayAction = false;
      } else {
        action.displayAction = true;
      }
    });
  }

  private _setDisplayFlags() {
    if (this.candidateJobMatch.jobMatchScore !== null && this.candidateJobMatch.jobMatchScore.toString() != '') {
      this.showIntelligenceScoreFlag = true;
      if (this.candidateJobMatch.jobMatchScore >= this.candidateJobMatch.fourDotFiveIntelligenceScore) {
        this.intelligenceScorePassFlag = true;
      }
      this.candidateJobMatch.jobMatchScore = Math.floor(parseFloat(this.candidateJobMatch.jobMatchScore));
    }
    if (this.candidateJobMatch.techAssessmentScore !== null && this.candidateJobMatch.techAssessmentScore.toString() != '') {
      this.showTechAssessmentScoreFlag = true;
      if (this.candidateJobMatch.techAssessmentScore >= this.candidateJobMatch.techAssessmentThresholdScore) {
        this.techAssessmentScorePassFlag = true;
      }
      this.candidateJobMatch.techAssessmentScore = Math.floor(parseFloat(this.candidateJobMatch.techAssessmentScore));
    }
    if (this.candidateJobMatch.valueAssessmentScore !== null && this.candidateJobMatch.valueAssessmentScore.toString() != '') {
      this.showValueAssessmentScoreFlag = true;
    }
    if (((this.candidateJobMatch.jobMatchCurrentState == 'Phone Screen Scheduled' || this.candidateJobMatch.jobMatchCurrentState == 'Phone Screen In Progress' || this.candidateJobMatch.jobMatchCurrentState == 'Phone Screen Completed' || this.candidateJobMatch.jobMatchCurrentState == 'Phone Screen Overdue' || this.candidateJobMatch.jobMatchCurrentState == 'Joined' || this.candidateJobMatch.jobMatchCurrentState == 'Filled') && this.candidateJobMatch.numberOfOpenPhoneScreens > 0) || this.candidateJobMatch.jobMatchCurrentState == 'Phone Screen Canceled') {
      this.showPhoneScreenCountFlag = true;
    }
    if (((this.candidateJobMatch.jobMatchCurrentState == 'Interview Scheduled' || this.candidateJobMatch.jobMatchCurrentState == 'Interview In Progress' || this.candidateJobMatch.jobMatchCurrentState == 'Interview Completed' || this.candidateJobMatch.jobMatchCurrentState == 'Interview Overdue' || this.candidateJobMatch.jobMatchCurrentState == 'Joined' || this.candidateJobMatch.jobMatchCurrentState == 'Filled') && this.candidateJobMatch.numberOfOpenInterviews > 0) || this.candidateJobMatch.jobMatchCurrentState == 'Interview Canceled') {
      this.showInterviewCountFlag = true;
      this.showPhoneScreenCountFlag = false;
    }
    if ((this.candidateJobMatch.jobMatchCurrentState && this.candidateJobMatch.jobMatchCurrentState.indexOf('Assessment') != -1) && (this.candidateJobMatch.jobMatchCurrentState != 'In Tech Assessment') && (this.candidateJobMatch.jobMatchCurrentState != 'In Value Assessment')) {
      this.showAssessmentInfoFlag = true;
    }

    if (this.candidateJobMatch.techAssessmentAdditionalInfoDto !== null && this.candidateJobMatch.techAssessmentAdditionalInfoDto !== undefined) {
      (this.candidateJobMatch.techAssessmentAdditionalInfoDto.commentList || []).forEach((comment) => {
        comment.showShortMessageFlag = true;
        comment.lastModifiedDate = new Date(comment.lastModifiedDate);
      });
    }
  }

  checkWorkflowFirstStepFirstState(currentState, actionType) {
    const firstActionOfFirstStepOfWorkflow = ['START_SCREENING', 'SEND_TECHNICAL_ASSESSMENT', 'SEND_VALUE_ASSESSMENT', 'SCHEDULE_PHONE_SCREEN', 'SCHEDULE_INTERVIEW'];
    const firstStateOfWorkflowSteps = ['In Soft Qualified', 'In Tech Assessment', 'In Value Assessment', 'In Phone Screen', 'In Interview'];
    return firstStateOfWorkflowSteps.includes(currentState) && firstActionOfFirstStepOfWorkflow.includes(actionType);
  }

  performAction(actionObject) {
    if (actionObject.action === 'Send Candidate Outreach') {
      const candidateType = this.candidateJobMatch.vendorName ? 'VENDOR_CANDIDATES' : 'OWN_CANDIDATES';
      this.candidateJobMatch.outreachActiveJob = true;
      this.candidateJobMatch.requisitionNumber = this.candidateJobMatch.jobMatchRequisitionNum;
      this.candidateJobMatch.jobTitle = this.candidateJobMatch.jobMatchTitle;
      this.candidateJobMatch.companyName = this.candidateJobMatch.clientOrBUName ? this.candidateJobMatch.clientOrBUName : this.candidateJobMatch.jobMatchClientName ? this.candidateJobMatch.jobMatchClientName : '';
      this.candidateJobMatch.jobLocationText = this.jobMatchService.setJobLocationText(this.candidateJobMatch.jobLocation);
      this.candidateJobMatch.jobId = this.candidateJobMatch.jobMatchJobId;
      this.jobMatchActionsService.openSendOutreachEmailModal(
        [this.candidateJobMatch],
        this.isVendorOnly,
        this.companyId,
        this.userId,
        this.candidateJobMatch.id,
        this.candidateJobMatch.clientOrBUId,
        candidateType,
        this.salaryDurationOptions,
        this.jobTypeList,
        this.candidateJobMatch.name,
        (data) => { });
    } else if (actionObject.actionType == 'RUN_CANDIDATE_SCORE') {
      this.alertsAndNotificationsService.showConfirm(actionObject.action, 'Are you sure you want to run the candidate score?', 'warning', true, () => {
        const requestObject = new RunCandidateScore(this.companyId, this.userId);
        requestObject.candidateId = this.candidateJobMatch.id;
        requestObject.jobMatchId = this.candidateJobMatch.jobMatchId;
        requestObject.rerunType = 'CANDIDATE_JOB';
        requestObject.candidateType = this.candidateJobMatch.vendorName ? 'VENDOR_CANDIDATES' : 'OWN_CANDIDATES';
        this.resumeService.reRunResumeScore(requestObject, (data) => {
          this.alertsAndNotificationsService.showAlertWithCallBack('Candidate scoring in Progress', data.message, 'success', () => { });
        }, (error) => {
          this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
      }, () => { });
    } else if (this.isFirstStep && this.checkWorkflowFirstStepFirstState(this.candidateJobMatch.jobMatchCurrentState, actionObject.actionType)) {
      const releasedCandidateDetail = this.candidateJobMatch.releasedCandidateDetail;
      const isCandidateAvailable = releasedCandidateDetail ? new Date() >= new Date(releasedCandidateDetail.releasedUpTo) : true;
      if (!isCandidateAvailable) {
        const suspendedMonths = releasedCandidateDetail.numberOfMonthsToWait;
        const candidateName = this.candidateJobMatch.firstName + ' ' + this.candidateJobMatch.lastName;
        const clientOrBuName = releasedCandidateDetail.releasedBy;
        const releaseDate = this.fourDotFiveDateFormatPipe.transform(releasedCandidateDetail.releasedAt);

        let displayHtmlText = "Candidate '<span class='emerald'>" + candidateName + "</span>' was released within the '<span class='emerald'>" + suspendedMonths + "</span>' month(s) of another job match for the same '<span class='emerald'>" + clientOrBuName + "</span>' with a release date of '<span class='emerald'>" + this.fourDotFiveDateFormatPipe.transform(releaseDate) + "</span>'";
        displayHtmlText = displayHtmlText + '<br></p><p>Do you still want to continue?</p>';

        this.alertsAndNotificationsService.showConfirm('Candidate Released', displayHtmlText, 'warning', true, () => {
          this.performJobMatchCardAction(actionObject);
        }, () => { });
      } else {
        this.performJobMatchCardAction(actionObject);
      }
    } else {
      if (actionObject.actionType == 'NOTES' || actionObject.actionType == 'COMMUNICATION' || actionObject.actionType == 'PEER_COMMUNICATION') {
        actionObject.candidateDetails = this._setJobMatchCandidateDetails('email', this.candidateJobMatch);
      }
      this.performJobMatchCardAction(actionObject);
    }
  }

  performJobMatchCardAction(actionObject) {
    actionObject.formalizeActivityPayload = {
      candidate: new FormalizeCandidate(this.candidateJobMatch.id, this.candidateJobMatch.firstName, this.candidateJobMatch.lastName),
      requisition: new FormalizeRequisition(this.candidateJobMatch.jobMatchJobId, this.candidateJobMatch.jobMatchRequisitionNum, this.candidateJobMatch.jobMatchTitle),
      jobMatch: new FormalizeJobMatch(this.candidateJobMatch.jobMatchId, this.candidateJobMatch.jobMatchJobId, this.candidateJobMatch.jobMatchRequisitionNum, this.candidateJobMatch.jobMatchTitle),
      company: new FormalizeCompany(this.companyId, this.candidateJobMatch.currentJobCompanyName, this.candidateJobMatch.clientOrBUId, this.candidateJobMatch.clientOrBUName)
    };
    this.jobMatchActionsService.performAction('candidateJobMatchCard', actionObject, this.candidateJobMatch, () => {
      this.saveCallback.emit();
    }, () => {
      if (actionObject.actionType != 'UPDATE_CONTACT') {
        this.refreshCard();
      }
    });
  }

  openMeetingsModal() {
    let meetingType = '';
    if (this.showInterviewCountFlag) {
      meetingType = 'Interview';
    } else if (this.showPhoneScreenCountFlag) {
      meetingType = 'PhoneScreen';
    }
    this.jobMatchActionsService.openMeetingsModal(this.jobMatchId, meetingType, () => {
      this.refreshCard();
    });
  }

  openAssessmentInfoModal() {
    let assessmentType = 'Tech Assessment';
    if (this.candidateJobMatch.jobMatchCurrentState.indexOf('Value Assessment') != -1) {
      assessmentType = 'Value Assessment';
    }
    this.jobMatchActionsService.openAssessmentInfoModal(this.jobMatchId, assessmentType);
  }

  openImageProctoringInfoModal() {
    this.jobMatchActionsService.openImageProctoringInfoModal(this.candidateJobMatch.techAssessmentReportInfoList[this.candidateJobMatch.techAssessmentReportInfoList.length - 1], this.candidateJobMatch.techAssessmentReportInfoList);
  }

  cardMenuToggled(openFlag, id) {
    if (openFlag) {
      setTimeout(() => {
        const menu = document.getElementById(id);
        const group = menu && menu.parentElement;
        if (!menu || !group || !group.classList.contains('open')) {
          return;
        }
        // The activity list is placed by its own `left: -290px !important` rule, which a fixed position would turn into a viewport offset.
        if (menu.classList.contains('candidate-job-match-activity-list')) {
          menu.scrollIntoView({ behavior: 'smooth', block: 'end' });
          return;
        }
        // The card list clips overflow, so the menu is pinned to the viewport next to the button.
        const rect = group.getBoundingClientRect();
        const menuHeight = menu.offsetHeight;
        const opensUp = rect.bottom + menuHeight > window.innerHeight && rect.top > menuHeight;
        // The theme transitions every property, which would animate the menu sliding in from its unpinned position.
        menu.style.transition = 'opacity 0.14s linear, transform 0.14s linear';
        menu.style.position = 'fixed';
        menu.style.left = 'auto';
        menu.style.right = (window.innerWidth - rect.right) + 'px';
        menu.style.top = (opensUp ? rect.top - menuHeight : rect.bottom) + 'px';
      }, 0);
    }
  }

  showAllActivityModal() {
    this.jobMatchActionsService.showAllActivityModal(this.candidateJobMatch, this.jobMatchId, this.activityMap);
  }

  expandText($event, comment) {
    comment.showShortMessageFlag = !comment.showShortMessageFlag;
    $event.stopPropagation();
  }

  toggleCardSelection() {
    this.candidateJobMatch.selectedFlag = !this.candidateJobMatch.selectedFlag;
  }

  showRecentActivities() {
    this.recentActivitiesControls.activityClickCount++;
    this.isActivityClicked = !this.isActivityClicked;
  }

  showNotifications() {
    this.userNotificationControls.notificationClickCount++;
    this.isNotificationClicked = !this.isNotificationClicked;
  }

  confirmOpeningPhoneConference() {
    this.alertsAndNotificationsService.showConfirm('Confirm', 'Do you want to call the candidate?', 'warning', true, () => {
      this._openPhoneConference();
    }, () => {
      // do nothing
    });
  }

  private _openPhoneConference() {
    let step = '';
    if (this.candidateJobMatch.currentStep === 'Recruiter Screening') {
      step = 'rs';
    } else if (this.candidateJobMatch.currentStep === 'Tech Assessment') {
      step = 'ta';
    } else if (this.candidateJobMatch.currentStep === 'Value Assessment') {
      step = 'va';
    } else if (this.candidateJobMatch.currentStep === 'Phone Screen') {
      step = 'ps';
    } else if (this.candidateJobMatch.currentStep === 'Interview') {
      step = 'in';
    } else if (this.candidateJobMatch.currentStep === 'Not Interested') {
      step = 'ni';
    } else if (this.candidateJobMatch.currentStep === 'Released') {
      step = 'r';
    }
    const absUrl = this.storageService.get('baseurl') + '/#/conference?jm=' + this.jobMatchId + '&ws=' + step + '&mode=PHONE';
    window.open(absUrl, '_blank');
  }

  private _setCandidateEmailSubjectAndBody(candidate) {
    const candidateInformation: any = {};
    candidateInformation.subject = `Candidate Information: ${candidate.firstName ? candidate.firstName : ''} ${candidate.lastName ? candidate.lastName : ''} – ${candidate.jobMatchTitle} (Req #${candidate.jobMatchRequisitionNum})`;
    candidateInformation.body = '';
    if (!candidate.candidateAdditionalDetails) {
      candidate.candidateAdditionalDetails = {};
    }
    candidate.candidateAdditionalDetails.preferredWorkLocations = this.candidateJobMatch.workLocations;
    candidateInformation.candidateInfoInEmailBody = this.jobMatchActionsService._setCandidateInfoInEmailBody(candidate, candidate.candidateAdditionalDetails);
    return candidateInformation;
  }

  private _setCandidateVendorDetails(candidate) {
    let vendorId = null;
    if (candidate.vendorName && this.assignedVendorDetails) {
      this.assignedVendorDetails.map(vendor => {
        if (vendor.vendorName == candidate.vendorName) {
          vendorId = vendor.vendorId;
        }
      });
    }
    return vendorId;
  }

  private _setJobMatchCandidateDetails(type, candidateJobMatch) {
    const candidateDetails: any = {};
    candidateDetails.context = 'candidateJobMatchCard';
    candidateDetails.resumeFileName = candidateJobMatch.resumePdfFileName;
    candidateDetails.resumeXRXml = candidateJobMatch.resumePdfFileName ? candidateJobMatch.resumePdfFileName.replace(/\.\w+/, '.xml') : '';
    candidateDetails.showOnlyJobMatchUsers = true;
    candidateDetails.candidateType = candidateJobMatch.vendorName ? 'VENDOR_CANDIDATES' : 'OWN_CANDIDATES';
    candidateDetails.jobMatchId = this.jobMatchId;
    candidateDetails.candidateEmailSubjectAndBodyInformation = this._setCandidateEmailSubjectAndBody(candidateJobMatch);
    candidateDetails.isSharedRequisition = candidateJobMatch.isSharedRequisition;
    candidateDetails.vendorId = this._setCandidateVendorDetails(candidateJobMatch);
    candidateDetails.corporateName = candidateJobMatch.corporateCompanyName;
    candidateDetails.jobMatchRequisitionId = candidateJobMatch.jobMatchJobId;
    candidateDetails.clientOrBuId = candidateJobMatch.clientOrBUId;
    candidateDetails.currentStep = candidateJobMatch.currentStep;
    if (type == 'email') {
      candidateDetails.candidateEmail = candidateJobMatch.email;
      candidateDetails.name = candidateJobMatch.firstName + candidateJobMatch.lastName;
      candidateDetails.candidateId = candidateJobMatch.id;
      candidateDetails.companyId = this.authService.getUserDetails().company.companyId;
      candidateDetails.showOnlyJobMatchUsers = true;
      candidateDetails.requisitionRecruitersList = this.allRecruitersAndHiringManagers;
    }

    return candidateDetails;
  }

  getCandidateJobMatches(successCallback) {
    const jobMatchesObject = new JobMatchQueryFilter();
    jobMatchesObject.candidateId = this.candidateJobMatch.id;
    jobMatchesObject.userId = this.userId;
    jobMatchesObject.companyId = this.companyId;
    jobMatchesObject.top5Flag = false;
    jobMatchesObject.candidateType = this.candidateJobMatch.vendorName ? 'VENDOR_CANDIDATES' : 'OWN_CANDIDATES';
    jobMatchesObject.searchText = '';
    jobMatchesObject.vendorIds = [];
    this.jobMatchService.getDetailedCandidateJobMatches(jobMatchesObject, this.companyId, 1, 250, (data) => {
      data.forEach((jobMatch) => {
        jobMatch.requisitionNumber = jobMatch.candidateJobMatchCardDetails.jobMatchRequisitionNum;
        jobMatch.jobLocationText = this.jobMatchService.setJobLocationText(jobMatch.jobLocation);
        jobMatch.candidateJobMatchCardDetails.availableActions.forEach((action) => {
          jobMatch.isOureachActionAvailable = action.actionType === 'SEND_OUTREACH';
        });
        jobMatch.jobMatchSelected = false;
      });
      if (successCallback) {
        successCallback(data);
      }
    }, (error) => {
      this.loadingFlag = false;
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  ngOnDestroy() {
    if (this.workFlowUpdateSubscription) {
      this.workFlowUpdateSubscription.unsubscribe();
    }
    if (this.incomingChatMessageSubscription) {
      this.incomingChatMessageSubscription.unsubscribe();
    }
  }
}
